import InitialState from './CareTeamNotificationPreferenceListInitialState'

import { ACTION_TYPES } from 'lib/Constants'

const {
    LOGOUT_SUCCESS,
    CLEAR_ALL_AUTH_DATA,

    CLEAR_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST,
    LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_REQUEST,
    LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_SUCCESS,
    LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_FAILURE
} = ACTION_TYPES

const initialState = new InitialState()

export default function careTeamNotificationPreferenceListReducer (state = initialState, action) {
    if (!(state instanceof InitialState)) {
        return initialState.mergeDeep(state)
    }

    switch (action.type) {
        case LOGOUT_SUCCESS:
        case CLEAR_ALL_AUTH_DATA:
        case CLEAR_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST:
            return state
                .setIn(['isFetching'], false)
                .setIn(['dataSource', 'data'], [])
                .removeIn(['error'])

        case LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_REQUEST:
            return state.setIn(['isFetching'], true)

        case LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_SUCCESS: {
            const data = action.payload

            const existingData = state.getIn(['dataSource', 'data'])

            return state
                .setIn(['isFetching'], false)
                .setIn(['shouldReload'], !existingData)
                .setIn(['dataSource', 'data'], data)
        }

        case LOAD_CARE_TEAM_NOTIFICATION_PREFERENCE_LIST_FAILURE:
            return state
                .setIn(['isFetching'], false)
                .setIn(['error'], action.payload)
    }

    return state
}
